"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestUserDetails = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const userQuery = (0, graphql_tag_1.default) `
  query UserDetails($userId: ID!) {
    user(id: $userId) {
      id
      firstName
      email
      lastName
      telephone
      birthdate
      enabled
      dummy
      inviteExisting
    }
  }
`;
const roleQuery = (0, graphql_tag_1.default) `
  query RoleUserDetails($workspaceId: ID!, $userId: ID!) {
    role(workspace: $workspaceId, user: $userId) {
      customData {
        employeeId
      }
      terminalPIN
    }
  }
`;
const requestUserDetails = async ({ workspaceId, userId }) => {
    const { data: roleData, errors: roleErrors } = await (0, apollo_1.query)(roleQuery, {
        variables: {
            workspaceId,
            userId,
        },
    });
    const { data: userData, errors: userErrors } = await (0, apollo_1.query)(userQuery, {
        variables: {
            userId,
        },
    });
    (0, error_handler_1.processErrors)(roleErrors);
    (0, error_handler_1.processErrors)(userErrors);
    return {
        user: userData?.user,
        terminalPIN: roleData?.role?.terminalPIN,
        customData: roleData?.role?.customData,
    };
};
exports.requestUserDetails = requestUserDetails;
